<h4>Office and LoB</h4>
<div class="layout-vbox" style="width: fit-content; gap: 2px">
    <div class="layout-hbox" style="gap: 10px">
        <fluent-dropdown type="combobox" placeholder="Select an office" autocomplete="both" ngFluentComboboxValueAccessor [(ngModel)]="officeKey">
            <fluent-listbox>
                <fluent-option value=""><em>All offices</em></fluent-option>
                @for (office of offices; track office.key) {
                    <fluent-option [attr.value]="office.key">{{office.name}}</fluent-option>
                }
            </fluent-listbox>
        </fluent-dropdown>
        <fluent-dropdown type="combobox" placeholder="Select a LoB" autocomplete="both" ngFluentComboboxValueAccessor [(ngModel)]="lobKey">
            <fluent-listbox>
                <fluent-option value=""><em>All LoBs</em></fluent-option>
                @for (lob of lobs; track lob.key) {
                    <fluent-option [attr.value]="lob.key">{{lob.name}}</fluent-option>
                }
            </fluent-listbox>
        </fluent-dropdown>

        <fluent-button (click)="onClearComboboxValues()">Clear</fluent-button>
    </div>
</div>
<h4>KPIs For Segment</h4>
<div class="layout-vbox" style="min-width: 800px; width: fit-content; flex: 1; height: 100px; gap: 10px">
    <wj-flex-grid #kpiSegmentGrid (initialized)="onKpiSegmentGridInitialized(kpiSegmentGrid)"
                  style="flex: 1; height: 200px; min-height: 200px;"
                  [showSelectedHeaders]="Wijmo.HeadersVisibility.All"
                  [showMarquee]="true"
                  [itemsSource]="kpiSegmentData"
                  [allowResizing]="Wijmo.AllowResizing.Both" [autoRowHeights]="true" [quickAutoSize]="false"
                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                  [isReadOnly]="true"
                  [autoGenerateColumns]="false"
    >
        <wj-flex-grid-filter #kpiSegmentGridFilter></wj-flex-grid-filter>
    </wj-flex-grid>

    <div class="layout-hbox" style="align-items: center; justify-content: flex-end; grid-gap: 10px;">
        <wj-flex-grid-search style="flex-grow: 1"
                             placeholder="Search key(s)"
                             [grid]="kpiSegmentGrid">
        </wj-flex-grid-search>
    </div>
</div>
